import React, { useMemo } from 'react';
import { useIsMobileWidth } from '@wix/ray-react-tools';
export const defaultDeviceTypeContext = {
  deviceType: 'desktop',
  isMobile: false
};
export const DeviceTypeContext = /*#__PURE__*/React.createContext(defaultDeviceTypeContext);
function getDeviceType() {
  switch (window.__DEVICE_TYPE__) {
    case 'mobile':
      return 'mobile';
    default:
      return 'desktop';
  }
}
export const DeviceTypeContextProvider = props => {
  const {
    children
  } = props;
  const isMobile = useIsMobileWidth();
  const contextValue = useMemo(() => ({
    deviceType: getDeviceType(),
    isMobile
  }), [isMobile]);
  return /*#__PURE__*/React.createElement(DeviceTypeContext.Provider, {
    value: contextValue
  }, children);
};
//# sourceMappingURL=DeviceTypeContext.js.map